import { HTTPService } from "../util/httpManager.js";
import { Helper } from "../util/helper.js";
import { Commands } from "../util/commandManager.js";
import { DatasourceUrlProcessor } from "../util/datasourceUrlProcessor.js";
import { BaseDataSourceComponentProps, BaseDataSourceField } from "./baseComponentProps.js";
import { CommandManagerAPI } from "../../commonInterfaces.js";
import React from "react";
export class ComboBox extends React.Component<ComboBoxProps, any>{
    private comboRef: any;
    private comboBox: kendo.ui.ComboBox;
    private value: any;
    private disabled = true;
    private lastDatasourceUrl: string;
    private icuh = Helper;
    private urlProcessor = new DatasourceUrlProcessor();

    componentWillUnmount() {
        this.comboBox.destroy();
    }

    componentDidMount() {
        this.disabled = this.props.disabled || false;
        this.value = this.props.value;
        var select = $(this.comboRef).kendoComboBox({
            value: this.value,
            //enable: !this._disabled,
            height: 300,
            dataSource: this.props.dataSource,
            dataTextField: this.props.field.dataTextField,
            dataValueField: this.props.field.dataValueField,
            change: (ev) => {
                this.value = ev.sender.value();
                let dataItem = ev.sender.dataItem();
                if (!Helper.hasValue(dataItem)) {
                    dataItem = {};
                    dataItem[this.props.field.dataTextField] = ev.sender.value();
                    dataItem[this.props.field.dataValueField] = ev.sender.value();
                }
                this.props.onChange(this.props.field, ev.sender.value(), dataItem)
            }
        });
        this.comboBox = select.data("kendoComboBox");
        this.comboBox.readonly(this.disabled);
        this.comboBox.wrapper.attr("data-readonly", this.disabled.toString());
        if (this.props.field.focus)
            this.comboBox.focus();

        if (this.props.field.listWidth !== null && window.matchMedia(`(min-width: ${this.props.field.listWidth}px)`).matches)
            this.comboBox.list.width(this.props.field.listWidth);

        if (this.props.field.dataSourceUrl !== undefined && this.props.field.dataSourceUrl !== null && this.props.field.dataSourceUrl !== "") {
            HTTPService.get(this.props.field.dataSourceUrl)
                .then(data => {
                    this.comboBox.setDataSource(data);
                    this.setState({});
                    //wenn keine DS setzt Kendo keinen Wert -- muss wieder gesetzt werden
                    this.comboBox.value(this.value);
                    this.props.onDataLoaded(this.props.field, data);
                }
                );
        }

        if (Helper.hasValue(this.props.commandManager)) {
            this.props.commandManager.registerExecutor(this.props.field.model, (command, data) => {
                if (command === Commands.RELOADDATASOURCE) {
                    this.comboBox.dataSource.data(this.props.dataSource);
                    this.comboBox.value(this.value);
                }
            });
        }
    }

    private isValueInData = (data: object[]) => {
        let validValue = false;
        for (let i = 0; i < data.length; i++) {
            let v = this.icuh.getValueByPathString(data[i], this.props.field.dataValueField);
            if (v === this.value) {
                validValue = true;
                break;
            }
        }

        return validValue;
    }

    private loadDataFromUrl = (dataSourceUrl: string) => {
        this.lastDatasourceUrl = dataSourceUrl;
        HTTPService.get(dataSourceUrl).then(data => {
            this.comboBox.setDataSource(data);
            //wenn keine DS setzt Kendo keinen Wert -- muss wieder gesetzt werden
            if (this.isValueInData(data) || !this.icuh.hasValue(this.value) || this.value === "") {
                this.comboBox.value(this.value);
            } else {
                this.comboBox.value(null);
                this.comboBox.text("");
                if (!this.props.field.readOnly && this.props.field.valueNullIfNotInDS) {
                    this.props.onChange(this.props.field, null, null)
                }
            }
            this.props.onDataLoaded(this.props.field, data);
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const isDisabled = this.props.disabled || false;
        if (this.disabled !== isDisabled) {
            this.disabled = isDisabled;
            this.comboBox.readonly(this.disabled);
            this.comboBox.wrapper.attr("data-readonly", this.disabled.toString());
        }
        if (this.value !== this.props.value) {
            this.value = this.props.value;
            this.comboBox.value(this.value);
        }

        if (this.urlProcessor.dataSourceUrlHasTemplate(this.props.field.dataSourceUrl)) {
            const newUrl = this.urlProcessor.processTemplate(this.props.field.dataSourceUrl, this.props.handleEval);
            if (newUrl !== this.lastDatasourceUrl) {
                this.loadDataFromUrl(newUrl);
            }
        }
        else if (Helper.hasValue(this.props.field.dataSourceUrl) && this.props.field.dataSourceUrl !== "" && this.props.field.dataSourceUrl != prevProps.field.dataSourceUrl) {
            this.loadDataFromUrl(this.props.field.dataSourceUrl);
        }

        if (this.props.field.refreshDSOnRefChange && this.props.dataSource != prevProps.dataSource) {
            this.comboBox.dataSource.data(this.props.dataSource);
            this.comboBox.value(this.value);
        }
    }

    render() {
        return (
            <input ref={(r) => this.comboRef = r} name={this.props.field.model} style={{ width: "100%" }} required={this.props.required} data-label={this.props.field.name} />
        );
    }
};

export interface ComboBoxProps extends BaseDataSourceComponentProps {
    field: ComboBoxField;
    commandManager?: CommandManagerAPI;
    handleEval?(action: string, prepare?: any);
}

export interface ComboBoxField extends BaseDataSourceField {
    listWidth?: number;
    focus?: boolean;
    valueNullIfNotInDS?: boolean;
}